import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IReportParam } from '../model/reportparam';
import { IAdmissionStatusReportParam } from '../model/admissionStatusReportParam';

@Injectable({ providedIn: 'root' })

export class ReportsService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    getSeasonReport(sportSeasonId: number, isCreated: boolean) {
        return this.http.get(env.apiUrl + 'report/seasonreport/' + sportSeasonId + '/' + isCreated, {
            responseType: 'blob'
        });
    }

    getEligibilityReport(startDate: Date, endDate: Date) {
        return this.http.get(env.apiUrl + 'report/eligibilitychangereport/' + startDate + '/' + endDate, {
            responseType: 'blob'
        });
    }

    getEligibilityCertificationReport(startDate: Date, endDate: Date) {
        return this.http.get(env.apiUrl + 'report/EligibilityCertificationReport/' + startDate + '/' + endDate, {
            responseType: 'blob'
        });
    }

    getQuitTeamChangeReport(startDate: Date, endDate: Date) {
        return this.http.get(env.apiUrl + 'report/quitteamdatechangereport/' + startDate + '/' + endDate, {
            responseType: 'blob'
        });
    }


    getFallAidReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/GetFallAid/' + sportSeasonId, { responseType: 'blob' });
    }
    participationCodeActivityReport(reportParam: IReportParam) {
        return this.http.post(env.apiUrl + 'report/ParticipationCodeActivityReport/', reportParam, {
            responseType: 'blob'
        });
    }
    residenceActivityReport(reportParam: IReportParam) {
        return this.http.post(env.apiUrl + 'report/ResidenceActivityReport/', reportParam, {
            responseType: 'blob'
        });
    }
    getAthletesReceivingOutsideAid(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/GetAthletesReceivingOutsideAid/' + sportSeasonId, { responseType: 'blob' });
    }

    athletesbyCollegeReport(sportSeasonId: number, institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesbyCollegeReport/' + sportSeasonId + '/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    internationalStudentAthletesReport(sportSeasonId: number, institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/InternationalStudentAthletesReport/' + sportSeasonId + '/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    midtermGradesForAthletesReport(sportSeasonId: number, institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/MidtermGradesForAthletesReport/' + sportSeasonId + '/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    finalGradesForAthletesReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/FinalGradesForAthletesReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    semesterGpaReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/SemesterGpaReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    annualGpaReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AnnualGpaReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    secHonorRollReport(sportSeasonId: number, runType: string) {
        return this.http.get(env.apiUrl + 'report/SecHonorRollReport/' + sportSeasonId + '/' + runType, {
            responseType: 'blob'
        });
    }
    athletedegreeprogrambycollegeReport(sportSeasonId: number, institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthleteDegreeProgramByCollege/' + sportSeasonId + '/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    athletesAidUpdateReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthleticAidUpdateReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    athletesGraduating() {
        return this.http.get(env.apiUrl + 'report/AthletesGraduating', {
            responseType: 'blob'
        });
    }
    athleteImmunization() {
        return this.http.get(env.apiUrl + 'report/AthleteImmunizationStatusReport', {
            responseType: 'blob'
        });
    }
    athletesWithBookScholarship(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesWithBookScholarships/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    athletesneedingcorbetter(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesNeedingCOrBetter/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    aprListReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AprListReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    aprSupplementalReport() {
        return this.http.get(env.apiUrl + 'report/AprSupplementalReport', {
            responseType: 'blob'
        });
    }
    notCertifiedReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/NotCertifiedReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    athleteAddressReport(sportSeasonId: number, addressTypeId: number) {
        return this.http.get(env.apiUrl + 'report/AthleteAddressReport/' + sportSeasonId + '/' + addressTypeId, {
            responseType: 'blob'
        });
    }
    athletesBySeasonReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesBySeasonReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    admissionStatusReport(admissionStatusReportParam: IAdmissionStatusReportParam) {
        return this.http.post(env.apiUrl + 'report/AdmissionStatusReport/', admissionStatusReportParam, {
            responseType: 'blob'
        });
    }
    admissionStatusReportDocuments(admissionStatusReportParam: IAdmissionStatusReportParam) {
        return this.http.post(env.apiUrl + 'report/AdmissionStatusReportDocuments/', admissionStatusReportParam, {
            responseType: 'blob'
        });
    }
    ncaaCompositeReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/NCAACompositeReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    ncaaSurveyExportReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/NCAASurveyExportReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    semesterAthletesReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/SemesterAthletesReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    officialVisitTrackingReport(reportParam: IReportParam) {
        return this.http.post(env.apiUrl + 'report/OfficialVisitTrackingReport/', reportParam, {
            responseType: 'blob'
        });
    }
    athletesbyPrimarySportReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesbyPrimarySportReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    fifthsemesterathletes(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/FifthSemesterAthletesReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    sportRosterReport(sportSeason: number, sportType: number, activeOnly: boolean, scholarshipOnly: boolean) {
        return this.http.get(env.apiUrl + 'report/SportRosterReport/' + sportSeason + '/' + sportType + '/' + activeOnly + '/' + scholarshipOnly, {
            responseType: 'blob'
        });
    }
    squadListReport(sportSeason: number, sportType: number) {
        return this.http.get(env.apiUrl + 'report/SquadListReport/' + sportSeason + '/' + sportType, {
            responseType: 'blob'
        });
    }
    squadListExcel(sportSeason: number, sportType: number) {
        return this.http.get(env.apiUrl + 'report/SquadListExcel/' + sportSeason + '/' + sportType, {
            responseType: 'blob'
        });
    }
    athleteWithdrawalReasonReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AthleteWithdrawalReasonReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    athletesRecievingAthleticAidReport(institutionTermId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesReceivingAthleticAidReport/' + institutionTermId, {
            responseType: 'blob'
        });
    }
    athletesAgeAtEnrollmentReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesAgeAtEnrollmentReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    initialSpringAidReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/InitialSpringAidReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    athletesWithPendingAidReport(sportSeasonId: number) {
        return this.http.get(env.apiUrl + 'report/AthletesWithPendingAidReport/' + sportSeasonId, {
            responseType: 'blob'
        });
    }
    nonAthleticAidActivityReport(startDate: Date, endDate: Date) {
        return this.http.get(env.apiUrl + 'report/NonAthleticAidActivityReport/' + startDate + '/' + endDate, {
            responseType: 'blob'
        });
    }
    exhaustedEligibilityTermsReport() {
        return this.http.get(env.apiUrl + 'report/ExhaustedEligibilityTermsReport', {
            responseType: 'blob'
        });
    }
}
